const {REACT_APP_SEND_OTP='',
  REACT_APP_VALIDATE_OTP='',
  REACT_APP_CREATE_RECORDS='',
  REACT_APP_NEWS_URL=''
} = process.env


export const SEND_OTP_API = REACT_APP_SEND_OTP;
export const VALIDATE_OTP_API = REACT_APP_VALIDATE_OTP;
export const CREATE_RECORD_API = REACT_APP_CREATE_RECORDS;
export const NEWS_API = REACT_APP_NEWS_URL